// State for files attached while booking. Each file is uploaded the moment it is
// picked, in its own step, so that "Create group" only has to save the booking.
// Pure reducer + helpers; the hook that drives them is useBookingUploads.js.

export function uploadsReducer(state, action) {
  const list = state[action.slot] || [];
  switch (action.type) {
    case "add": {
      const next = action.multiple ? [...list, action.item] : [action.item]; // a single slot is replaced
      return { ...state, [action.slot]: next };
    }
    case "done":
      return { ...state, [action.slot]: list.map((i) => (i.id === action.id ? { ...i, status: "done", url: action.url } : i)) };
    case "fail":
      return { ...state, [action.slot]: list.map((i) => (i.id === action.id ? { ...i, status: "error", error: action.error } : i)) };
    case "retry":
      return { ...state, [action.slot]: list.map((i) => (i.id === action.id ? { ...i, status: "uploading", error: "" } : i)) };
    case "remove":
      return { ...state, [action.slot]: list.filter((i) => i.id !== action.id) };
    case "clear":
      return {};
    default:
      return state;
  }
}

// An upload that finishes after its file was replaced or removed must be
// ignored; the reducer does that by matching on id (no match, no change).
export const itemsOf = (state, slot) => state[slot] || [];
export const urlsOf = (state, slot) => itemsOf(state, slot).filter((i) => i.status === "done").map((i) => i.url);
export const isUploading = (state) => Object.values(state).some((list) => list.some((i) => i.status === "uploading"));
export const hasFailed = (state, slot) => itemsOf(state, slot).some((i) => i.status === "error");

// Newline-separated, the shape the API stores for several files.
export const joinUrls = (urls) => urls.join("\n");
